import React from 'react';
import { connect } from 'react-redux';
import { Accordion, Box, Divider } from '@drone-js/core';
import { mapStateToProps, LocationProps } from 'component/page/detail/MoreInfoSections/Location/Location.selectors';
import LocationCard from 'component/page/detail/MoreInfoSections/Location/LocationCard';

import { trackElementEvent } from 'core/messaging/analytics/analytics';
import DetailInViewWrapper from 'component/common/DetailInViewWrapper/DetailInViewWrapper';
import { setSelectedTabOnDetailsPage } from 'component/page/detail/store/details';
import { ActivitiesLocationContainerSeenEventActivitiesFieldsV1 } from '@agoda/analytics-messages-definition-activities/events.split';
import {
    ActivitiesLocationContainerClickEventActivitiesManifestV1,
    ActivitiesLocationContainerSeenEventActivitiesManifestV1,
} from '@agoda/analytics-messages-definition-activities/manifest/events';
import { InView } from 'react-intersection-observer';

const Location: React.FC<LocationProps> = (props) => {
    const { cms, onToggle, expandedAccordion } = props;
    const locationSectionState = expandedAccordion[`#${props.href}` || ''] ? 'expanded' : 'collapsed';

    const onSeen = (inView: boolean) => {
        if (inView) {
            trackElementEvent<ActivitiesLocationContainerSeenEventActivitiesFieldsV1>(ActivitiesLocationContainerSeenEventActivitiesManifestV1.ids, {
                is_toggle_on: locationSectionState === 'expanded',
            });
        }
    };

    return (
        <InView onChange={onSeen} triggerOnce={true} threshold={1}>
            <DetailInViewWrapper tabHref={props.href || ''} isScrolling={props.isScrolling} setSelectedTabCallback={setSelectedTabOnDetailsPage}>
                <Accordion
                    id={props.href}
                    contentSummary={cms[20536]}
                    actionType="chevron-icon"
                    onToggle={onToggle(`#${props.href}` || '', ActivitiesLocationContainerClickEventActivitiesManifestV1.ids)}
                    data-element-name="activities-location-container"
                    level={2}
                    view={locationSectionState}
                >
                    <Box data-testid="activities-location-info" mb="12">
                        <LocationCard locationDetails={props.locationDetails} />
                    </Box>
                </Accordion>
                <Divider direction="horizontal" my="4" />
            </DetailInViewWrapper>
        </InView>
    );
};
Location.displayName = 'Location';

export default connect(mapStateToProps)(Location);
